const offcanvasMenu = () => {
  $('#offcanvas .menu-item-has-children').addClass('offcanvas-has-dropdown');
  $('#offcanvas')
    .find('li')
    .removeClass('menu-item-has-children');

  // First click on dropdown menu shows children, second navigates to link
  $('.offcanvas-has-dropdown').each((i, e) => {
    // each dropdown has its own scope with its variables
    const $this = $(e);
    $this.children('a').click(anchorClickEvent => {
      const $anchor = $(anchorClickEvent.currentTarget);

      if (!$this.hasClass('opened')) {
        $('.offcanvas-has-dropdown.opened').each((i, e) => {
          $(e).removeClass('opened').find('ul').slideUp(500);
        });

        $this.addClass('opened').find('ul').slideDown(500);

        // Add a span near the pseudo-element to allow the user to hide the children
        if ($anchor.find('span.offcanvas-prevent-click').length === 0) {
          const $span = $('<span></span>').addClass('offcanvas-prevent-click').css({
            height: $anchor.height(),
            width: $anchor.height() * 2,
            display: 'inline-block',
            float: 'right',
          });

          $span.click(spanClickEvent => {
            if ($this.hasClass('opened')) {
              spanClickEvent.preventDefault();
              spanClickEvent.stopImmediatePropagation();
              $this.removeClass('opened').find('ul').slideUp(500);
            }
          });

          $span.appendTo($anchor);
        }

        anchorClickEvent.preventDefault();
        anchorClickEvent.stopImmediatePropagation();
      }
    });
  });
};

const burger = () => {
  const $body = $('body');
  $body.on('click', '.js-nav-toggle', function (e) {
    const $this = $(this);

    if ($body.hasClass('offcanvas')) {
      $body.removeClass('offcanvas');
    } else {
      $body.addClass('offcanvas');
    }

    $this.toggleClass('active');

    e.preventDefault();
  });
};

// Should only be fired once since it listens on a window event
const closeMenuOnwindowResize = () => {
  const $body = $('body');

  $(window).resize(function () {
    if ($body.hasClass('offcanvas')) {
      $body.removeClass('offcanvas');
      $('.js-nav-toggle').removeClass('active');
    }
  });
};

// Mobile outside click close offcanvas
const closeMenuOnOutsideClick = function () {

  const clickHandler = function (e) {
    const container = $('#offcanvas, .js-nav-toggle');
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      if ($('body').hasClass('offcanvas')) {
        $('body').removeClass('offcanvas');
        $('.js-nav-toggle').removeClass('active');
      }
    }
  };

  $(document).click(clickHandler);

  const $body = $(document.body);
  // Removes click handler on document when the contact modal is opened
  $body.on('show.bs.modal', function () {
    $(document).off('click', clickHandler);
  });

  // Registers the click handler again when the contact modal is closed
  $body.on('hidden.bs.modal', function () {
    $(document).click(clickHandler);
  });
};

export default {
  runOnce: () => {
    burger();
    closeMenuOnwindowResize();
    closeMenuOnOutsideClick();
  },
  beforeRun: () => {
    offcanvasMenu();
  },
};
